import { Box, Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactJson from "react-json-view";

const PaymentDetailModal = ({
  dataById,
  setOpenPaymentModal,
  openPaymentModal,
}) => {
  let txnBody = {};
  let isValidJson = true;

  const raw = dataById?.[0]?.txn_body;

  try {
    txnBody = typeof raw === "string" ? JSON.parse(raw) : raw || {};
  } catch (e) {
    isValidJson = false;
    txnBody = raw || "No transaction data available";
  }

  return (
    <Dialog
      open={openPaymentModal}
      onClose={() => setOpenPaymentModal(false)}
      fullWidth
      maxWidth="sm"
   PaperProps={{
  sx: {
    maxWidth: "800px",      // maximum width for large screens
    width: "95%",           // responsive width for small screens
    border: "2px solid #7C1386",
    borderRadius: "10px",
    m: 0,                   // remove default margin
  },
}}

    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          flexWrap: "wrap", // allow wrapping on small screens
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center",flexDirection:{sm:"row",xs:"column"}}}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
            }}
          >
            Payment Details
          </Typography>
          <Typography
            variant="body2"
            sx={{
              ml: 1,
              color: "#555",
              fontWeight: "bold",
             
            }}
          >
            (ORDER ID: {dataById?.[0]?.txn_id || "N/A"})
          </Typography>
        </Box>

        <IconButton
          onClick={() => setOpenPaymentModal(false)}
          disableRipple
          sx={{
            color: "#000",
            p: 1,
            background: "rgb(0 0 0 / 4%)",
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon sx={{ fontSize: "1.3rem" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {isValidJson ? (
          <ReactJson
            src={txnBody}
            theme="monokai"
            collapsed={2}
            enableClipboard={false}
            displayDataTypes={false}
          />
        ) : (
          <Box
            sx={{
              bgcolor: "#f5f5f5",
              borderRadius: "8px",
              p: 2,
              fontFamily: "monospace",
              fontSize: "0.85rem",
              whiteSpace: "pre-wrap",
              overflowX: "auto",
              maxHeight: "400px",
            }}
          >
            {txnBody}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDetailModal;
